/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-10-14 15:47:00
 * @LastEditors: Andy
 * @LastEditTime: 2022-12-15 19:34:27
 */
import Cookies from 'js-cookie'

// const TokenKey = 'Admin-Token'

const TokenService = {
  setToken(key, value) {
    // Cookies.set(key, value)
    localStorage.setItem(key, value)
  },
  setExToken(key, value, days) {
    // Cookies.set(key, value, { expires: days })
    localStorage.setItem(key, value)
  },
  getToken(key) {
    // return Cookies.get(key)
    return localStorage.getItem(key)
  },
  removeToken(key) {
    // Cookies.remove(key)
    localStorage.removeItem(key)
  }
}

export default TokenService
